import React from "react";
import { Helmet } from 'react-helmet-async';
import '../../../assets/styles/Print.css'
import printHero from "../../../assets/images/Print Design.png";
import printSamples from "../../../assets/images/Print Design.png";

const PrintDesign = () => {
  return (
    <>
      <Helmet>
        {/* <!-- Primary Meta Tags for SEO --> */}
        <title> Print Design – BuddyTech Solutions </title>
        <meta name="description" content="Brochures, flyers, posters and business cards with professional print-ready layouts." />
        <meta name="keywords" content="print design, brochures, flyers" />

        {/* <!-- Open Graph / Facebook Meta Tags --> */}
        <meta property="og:title" content="Print Design – BuddyTech Solutions" />
        <meta property="og:description" content="Brochures, flyers, posters and business cards with professional print-ready layouts." />
        <meta property="og:keywords" content="print design, brochures, flyers" />
        <meta property="og:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
        <meta property="og:url" content="https://buddytechsolutions.in/services/graphics/print" />
        <meta property="og:type" content="website" />

        {/* <!-- Optional: Facebook App ID --> */}
        {/* <!-- <meta property="fb:app_id" content="your_facebook_app_id" /> --> */}

        {/* <!-- Twitter Meta Tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Print Design – BuddyTech Solutions" />
        <meta name="twitter:description" content="Brochures, flyers, posters and business cards with professional print-ready layouts." />
        <meta name="twitter:keywords" content="print design, brochures, flyers" />
        <meta name="twitter:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
      </Helmet>
      <div className="print-container">
        <header className="print-hero">
          <div className="print-hero-content">
            <h1>Print Design Services</h1>
            <p>
              We bring your brand to life in the physical world through visually compelling print media that leaves a lasting impression.
            </p>
          </div>
          <img src={printHero} alt="Print Design Hero" className="print-hero-img" />
        </header>

        <section className="print-section">
          <div className="print-text">
            <h2>What We Design</h2>
            <p>
              Whether you're preparing for a product launch, trade show, or just need everyday business materials, we deliver high-quality print-ready designs that match your brand’s style and message.
            </p>
            <ul>
              <li>Business Cards & Stationery</li>
              <li>Flyers & Posters</li>
              <li>Brochures & Catalogs</li>
              <li>Banners & Event Signage</li>
              <li>Packaging & Labels</li>
            </ul>
          </div>
          <img src={printSamples} alt="Print Design Samples" className="print-img" />
        </section>

        <section className="print-tools">
          <h2>Design Tools We Use</h2>
          <div className="tools-grid">
            <span>Adobe InDesign</span>
            <span>Adobe Illustrator</span>
            <span>Photoshop</span>
            <span>CorelDRAW</span>
            <span>Figma</span>
            <span>Canva</span>
          </div>
        </section>

        <section className="contact-options">
          <div className="contact-card email">
            <h2>📧 Email</h2>
            <p>Send us an email for inquiries, support or collaboration opportunities.</p>
            <a href="mailto:developerjayaprakash91@gmail.com" target="_blank" rel="noopener noreferrer">
              Send Email
            </a>
          </div>

          <div className="contact-card whatsapp">
            <h2>💬 WhatsApp</h2>
            <p>Start a chat with us on WhatsApp for quick responses and updates.</p>
            <a href="https://wa.me/919842084312" target="_blank" rel="noopener noreferrer">
              Chat on WhatsApp
            </a>
          </div>

          <div className="contact-card phone">
            <h2>📞 Call Us</h2>
            <p>Prefer to talk directly? Give us a call anytime during business hours.</p>
            <a href="tel:+919842084312">Call Us</a>
          </div>
        </section>
      </div>
    </>
  );
};

export default PrintDesign;